import { createGlobalStyle } from 'styled-components';
import resetStyles from './resetStyles';
import fontsStyles from './fontsStyles';
import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';

const GlobalStyle = createGlobalStyle`
    ${resetStyles};
    ${fontsStyles};
    * {
        box-sizing: border-box;
    };
    body {
        ${({ theme }) => theme.fonts.mulishRegular};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    };
    h1 {
        ${({ theme }) => theme.fonts.comfortaaBold};
        font-size: 24px;
        line-height: 1.2em;
        letter-spacing: -0.025em;
        color: ${({ theme }) => theme.colors.darkGrey};
    };
    h2 {
        ${({ theme }) => theme.fonts.mulishLight};
        font-size: 14px;
        line-height: 1.2em;
        letter-spacing: -0.025em;
        color: ${({ theme }) => theme.colors.darkGrey};
    };
    h3 {
        ${({ theme }) => theme.fonts.mulishRegular};
        font-size: 11px;
        line-height: 1.2em;
        letter-spacing: -0.025em;
        color: ${({ theme }) => theme.colors.darkGrey};
    }
    p {
        ${({ theme }) => theme.fonts.mulishLight};
        font-size: 14px;
        line-height: 1.8em;
        letter-spacing: -0.025em;
        color: ${({ theme }) => theme.colors.darkGrey};
    };
    .Toastify__toast {
        ${({ theme }) => theme.fonts.mulishRegular};
        font-size: 14px;
        line-height: 20px;
        border-radius: 10px;
    }
    .Toastify__toast-body {
        padding: 0 8px;
    }
    .Toastify__toast--error {
        background-color: #E63004;
    }
    .Toastify__toast--success {
        background-color: #32AAD8;
    }
`;

export default GlobalStyle;